import {getRequest, sendRequest} from './api';

/**
 * Получение списка рабочих мест организации.
 * @param {string} organisation_id - Идентификатор организации.
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function fetchStaff(organisation_id) {
  return getRequest(`/workplace/user`, {organisation_id});
}

/**
 * Добавление пользователя на рабочее место.
 * @param {object} data - Данные для добавления пользователя (обязательные параметры: organisation_id, workplace_id, login, role_id ).
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function addUserToWorkplace(data) {
  return sendRequest('/workplace/user/invite', 'POST', data);
}

/**
 * Увольнение Работающего сотрудника
 * @param {object} data - Данные для удаления пользователя (обязательные параметры: organisation_id, id).
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function dismissalUserFromWorkplace(data) {
  return sendRequest('/workplace/user', 'DELETE', data);
}
/**
 * Удаление сотрудника со статусом awaiting с рабочего места.
 * @param {object} data - Данные для удаления пользователя (обязательные параметры: organisation_id, id).
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function removeUserFromWorkplace(data) {
  return sendRequest('/workplace/user/invite', 'DELETE', data);
}

// export async function executeNoticeWorkerAdd(data) {
//   return sendRequest(' /execute/notice/worker/add');
// }

/**
 * Получение рабочих мест текущего пользователя
 * @param {}
 * @returns {Promise<any>} - Ответ от сервера
 */
export async function getWorkplaceUser() {
  return getRequest('/user/workplace', {});
}

/**
 * Принятие приглашения:
 * Метод: put
 * @param {
 * "workplace_id":"6808dc0d-aa16b791-3244-4043-bfdbe363dc40",
 *  "sender_id": "67e3ad9d-56fd21bf-605b-416b-b90b6091a40f"}
 * @returns {Promise<any>} - Ответ от сервера
 */
export async function setConfirmInvite(data) {
  return sendRequest('/workplace/user/invite/confirm', 'PUT', data);
}
